import React from "react";
import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, Newspaper, Image as ImgIcon, Trophy, Inbox, Briefcase, Calendar } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="p-10 text-gray-500">Caricamento…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;

  const items = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, tid: "adm-nav-dashboard" },
    { to: "/admin/news", label: "News Racing", icon: Newspaper, tid: "adm-nav-news" },
    { to: "/admin/eventi", label: "Eventi", icon: Calendar, tid: "adm-nav-events" },
    { to: "/admin/lavora-con-noi", label: "Lavora con noi", icon: Briefcase, tid: "adm-nav-jobs" },
    { to: "/admin/gallery", label: "Gallery", icon: ImgIcon, tid: "adm-nav-gallery" },
    { to: "/admin/racing-story", label: "Storia Racing", icon: Trophy, tid: "adm-nav-story" },
    { to: "/admin/richieste", label: "Richieste", icon: Inbox, tid: "adm-nav-requests" },
  ];

  return (
    <div className="min-h-screen grid md:grid-cols-[260px_1fr] bg-gray-50">
      <aside className="bg-gray-900 text-white p-6 flex flex-col">
        <Link to="/" className="font-display uppercase text-3xl">NSA</Link>
        <div className="label-eyebrow text-white/50 mt-1">Admin</div>

        <nav className="mt-10 flex-1 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 rounded-sm label-eyebrow transition ${
                  isActive ? "bg-[color:var(--nsa-orange)] text-white" : "text-white/80 hover:bg-white/5 hover:text-white"
                }`
              }
              data-testid={it.tid}
            >
              <it.icon size={16} /> {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-6 border-t border-white/10 pt-6">
          <div className="text-sm text-white/70">{user.email}</div>
          <button
            onClick={logout}
            className="mt-3 flex items-center gap-2 label-eyebrow text-white/80 hover:text-[color:var(--nsa-orange)]"
            data-testid="adm-logout"
          >
            <LogOut size={14} /> Esci
          </button>
        </div>
      </aside>
      <main className="p-6 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}
